<template>
	<div :class="[bgClass]" class="flex flex-col" style="width: 100%; height: 100%">
		<div  style="z-index: 9999; " :style="[navFixed ? 'position: fixed; top:0rem; left:0rem; right: 0rem;' : '']">
			<slot name="navBar"></slot>
		</div>
		<div class="flex-1 overflow-y-scroll" style="width: 100%; height: 100%; -webkit-overflow-scrolling: touch;">
			<template v-if="!disablePullRefresh">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh" :loading-text="$t('公共.加载中')"
					:pulling-text="$t('公共.下拉刷新')" :loosing-text="$t('公共.释放刷新')">
					<van-list v-model="loading" :finished="more == 0" :loading-text="$t('公共.加载中')"
						finished-text=" " @load="onLoad">
						<slot name="content"></slot>
					</van-list>
				</van-pull-refresh>
			</template>
			<template v-else>
				<van-list v-model="loading" :finished="more == 0" :loading-text="$t('公共.加载中')"
					finished-text=" " @load="onLoad">
					<slot name="content"></slot>
				</van-list>
			</template>
		</div>
		<div class="fixed bottom-0 left-0 right-0" style="z-index: 2;">
			<slot name="menuBar"></slot>
		</div>
		<div class="fixed top-0 left-0" style="z-index: 2;">
			<slot name="popup"></slot>
		</div>
	</div>
</template>

<script>
import utils from "@/utils/utils.js";
import store from '@/store/index.js';
export default {
	props: {
		bgClass: {
			type: String,
			default: "page-bg-color"
		},
		navFixed: {
			type: Boolean,
			default: false
		},
		// 是否禁用下拉刷新（隐藏下拉与“加载中”提示，仅保留上拉）
		disablePullRefresh: {
			type: Boolean,
			default: false
		},
		triggered: {
			type: Boolean,
			default: false
		},
		more: {
			type: [Number, String],
			default: 1
		},
		// 是否需要滑动加载更多数据
		needMore: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			// 0 加载更多 1是下拉刷新
			type: 0,
			// 当前下拉刷新状态
			isLoading: false,
			loading: false,
		};
	},
	watch: {
		triggered(newVal) {
			if (this.type == 1) {
				this.isLoading = newVal;
			} else {
				this.loading = !newVal;
			}
		}
	},
	created() {

	},
	mounted() {
	},
	methods: {
		onRefresh() {
			this.type = 1
			this.$emit('refresherpulling')
		},
		onLoad() {
			if (!this.needMore) {
				this.loading = false;
				return
			}
			this.type = 0;
			this.$emit('scrolltolower')
		}
	},
}
</script>

<style scoped>
/* 添加微信浏览器滚动兼容样式 */
.overflow-y-scroll {
	overflow-y: scroll;
	-webkit-overflow-scrolling: touch;
	/* 启用惯性滚动 */
	transform: translateZ(0);
	/* 开启硬件加速 */
}
</style>
